import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { IndexWrapper } from "@framework/shared";

import { PaymentSplitterSection } from "../../../dashboard/mechanics/payment-splitter";
import { PaymentSplitterContracts } from "./contract";

export const paymentSplitterRoutes: Array<RouteObject> = [
  {
    path: "/payment-splitter",
    children: [
      {
        index: true,
        element: (
          <IndexWrapper index="payment-splitter">
            <PaymentSplitterSection />
          </IndexWrapper>
        ),
      },
      {
        path: "/payment-splitter/contracts",
        element: <Protected />,
        children: [
          { index: true, element: <PaymentSplitterContracts /> },
          { path: "/payment-splitter/contracts/:id/:action", element: <PaymentSplitterContracts /> },
        ],
      },
    ],
  },
];
